
      (function () {
        const filterLinks = document.querySelectorAll('.editorial-sections a[data-filter]');
        const cards = document.querySelectorAll('.editorial-card');

        filterLinks.forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            const filter = this.dataset.filter;

            filterLinks.forEach(function (l) { l.classList.remove('active'); });
            this.classList.add('active');

            cards.forEach(function (card) {
              const category = card.dataset.category || '';
              if (filter === 'all' || category === filter) {
                card.style.display = '';
              } else {
                card.style.display = 'none';
              }
            });
          });
        });
      })();
    